import { compact, flatMap } from "lodash/fp";

export const getSelectedListItemValues = (selectedListItems: {
  [page: number]: {
    [itemIndex: number]: any;
  };
}) => compact(flatMap(Object.values, Object.values(selectedListItems)));
